import {
  fetchRequest,
  readResponse,
} from "@otto-ec/assets-core-utils/nano-effect-web";
import type { Effect } from "@otto-ec/assets-core-utils/nano-effect";
import {
  flatMap,
  pipe,
  policy,
  retry,
  succeed,
} from "@otto-ec/assets-core-utils/nano-effect";
import type { CinemaDataDto } from "../types/CinemaProductsDto.types";

const EMPTY_CINEMA_DATA: CinemaDataDto = {
  auctionId: "",
  cinemaSponsoredProducts: [],
  cinemaTrackingLabels: {},
};

const MAX_RETRY_ATTEMPTS = 3;

function fetchEffect(variationId: string) {
  return pipe(
    fetchRequest(
      `/auction-otter/cinema/sponsored-products?variationId=${variationId}`,
      { method: "GET", headers: { Accept: "application/json" } },
    ),
    flatMap(
      (response) =>
        (response.status === 204
          ? succeed(EMPTY_CINEMA_DATA)
          : readResponse<CinemaDataDto>(
              response,
              (r) => r.json() as Promise<CinemaDataDto>,
            )) as Effect<CinemaDataDto, Error>,
    ),
  );
}

export function fetchCinemaProducts(variationId: string) {
  return retry(fetchEffect, policy({ times: MAX_RETRY_ATTEMPTS }))(variationId);
}
